
import React from 'react'

import why1 from "../../assets/Group 1000015011ab (1).png"
import why2 from "../../assets/Group 1000015011 (2).png"
import Stats from "../Home/Stats"

const AboutWhy = () => {
  return (
    <section className='mb-20 pt-[150px] md:pt-[70px]'>
      
        <section className='flex md:flex-col  md:w-[90%] justify-between w-[90%] mx-auto'>
           
            <section className='w-[45%] md:w-full my-auto' >
                <div className='flex'>
                    
                    <div className='ml-4 md:ml-0'>
                      <h2 className='font-semibold text-4xl'>Who are we?</h2>
                        <p className='text-[#555454] font-normal text-base mt-4'>
                        At Quest-Inspire, we're committed to empowering individuals to achieve their educational aspirations and unlock their full potential. With a passion for excellence and a dedication to innovation, we provide comprehensive education solutions tailored to meet the diverse needs of our students.
                        </p>
                    </div>
                </div>
                <div className='flex my-4'>
                    
                    <div className='ml-4 md:ml-0'>
                     
                        <p className='text-[#555454] font-normal text-base mt-4'>
                        Our team consists of experienced professionals who are experts in their respective fields, ensuring that our students receive the highest quality of instruction and support. Whether it's through our education consultancy services, tutorial programs, or study abroad opportunities, we strive to provide a holistic approach to learning that fosters growth and success.
                        </p>
                    </div>
                </div>
                <div className='flex'>
                    
                    <div className='ml-4 md:ml-0'>
                       
                        <p className='text-[#555454] font-normal text-base mt-4'>
                        At Quest-Inspire, we believe that education is the key to unlocking a world of opportunities. Join us on your educational journey and let us inspire and guide you towards a brighter future."
                        </p>
                    </div>
                </div>
            </section>
            <section className='md:w-full  w-[50%]'>
                <img src={why1} className='md:w-[90%] md:mx-auto object-cover  md:mt-8' alt="why one" />
            </section>
        </section>
        <section className='flex mb-20 md:flex-col md:w-[90%]  mt-16 md:mt-8 justify-between w-[90%] mx-auto'>
        <section className='md:hidden'>
                <img src={why2} className='object-cover' alt="why one" />
            </section>
        <section className='w-[45%] md:w-full my-auto' >
                <div className='flex'>
                    
                    <div className='ml-4 md:ml-0'>
                      <h2 className='font-semibold text-4xl'>Mission</h2>
                        <p className='text-[#555454] font-normal text-base mt-4'>
                        At Quest-Inspire, we're committed to empowering individuals to achieve their educational aspirations and unlock their full potential. With a passion for excellence and a dedication to innovation, we provide comprehensive education solutions tailored to meet the diverse needs of our students.
                        </p>
                    </div>
                </div>
                <div className='flex my-4'>
                    
                    <div className='ml-4 md:ml-0'>
                     
                        <p className='text-[#555454] font-normal text-base mt-4'>
                        Our team consists of experienced professionals who are experts in their respective fields, ensuring that our students receive the highest quality of instruction and support. Whether it's through our education consultancy services, tutorial programs, or study abroad opportunities, we strive to provide a holistic approach to learning that fosters growth and success.
                        </p>
                    </div>
                </div>
                <div className='flex'>
                    
                    <div className='ml-4 md:ml-0'>
                       
                        <p className='text-[#555454] font-normal text-base mt-4'>
                        At Quest-Inspire, we believe that education is the key to unlocking a world of opportunities. Join us on your educational journey and let us inspire and guide you towards a brighter future."
                        </p>
                    </div>
                </div>
            </section>
          
        </section>
      <Stats />
       
    </section>
  )
}

export default AboutWhy